import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstOfp: [],
        ofp: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getOfp(state) {
            let ofp = { ...state.ofp }
            return ofp
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
       isVaccumAndPurgeStarted: (state) => {
            if (!state.ofp || !state.ofp.ofphvpini)
                return false

            const data = new Date(state.ofp.ofphvpini)
            if (isNaN(data)) return false

            return data.getFullYear() !== 1899
        },

        isVaccumAndPurgeClosed: (state) => {
            if (!state.ofp || !state.ofp.ofphvpfim)
                return false

            const data = new Date(state.ofp.ofphvpfim)
            if (isNaN(data)) return false

            return data.getFullYear() !== 9999
        }


    },
    mutations: {
        set(state, ofp) {
			state.ofp = { ...ofp }
            if (ofp)
                state.update = true
		},
        initForm(state) {
            state.insert = false
            state.update = false
            state.ofp = {}
        },
        setParamsDataTable(state, payload) {
            state.lstOfp = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setOfp(state, ofp) {
            state.ofp = ofp
        },
        setLstOfp(state, lstOfp) {
            state.lstOfp = lstOfp
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, ofptriagem) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Oryxplace/Screening/Find/${ofptriagem}`)
                .then(response => {
                    let ofp = Utils.ValidateAxiosResponse(response.data);
                    commit("set", ofp)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async get({ dispatch }, ofpordem) {
            return await this._vm.$axios.get(`/Oryxplace/Screening/Find/${ofpordem}`)
            .then(response => {
                return Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return null
            });
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/OryxPlace/Screening/Insert", getters.getOfp)
                .then(response => {
                    let ofp = Utils.ValidateAxiosResponse(response.data);
                    commit('setLastUpdatedRegister', ofp);
                    commit("set", ofp)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Oryxplace/Screening/Update", getters.getOfp)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Oryxplace/Screening/Delete/${getters.getOfp.ofpordem}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    window.location.reload(true)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findByOrder({ state, commit, dispatch }, ofpordem) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/Oryxplace/Screening/FindByOrder/${ofpordem}`)
                .then(response => {
                    let ofp = Utils.ValidateAxiosResponse(response.data);
                    commit("set", ofp)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async findLastScreening({ dispatch }) {
            return await this._vm.$axios.get(`/Oryxplace/Screening/FindLastScreening/`)
                .then(response => {
                    return Utils.ValidateAxiosResponse(response.data);
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return null
                });
        },
    }
}